





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import gql from 'graphql-tag'
import ContentImage from '@/components/ContentImage.vue'

import FeedComment from '@/components/Feed/FeedComment.vue'
import FeedVote from '@/components/Feed/FeedVote.vue'

const fields = `
  uid
  createdAt
  createdBy {
    uid
    name
    profileImageUrl
  }
`
const pageSize = 10
@Component({
  components: { ContentImage, FeedComment, FeedVote },
  apollo: {
    activity: {
      variables() {
        return {
          userUid: this.uid,
          order: this.order,
          first: pageSize,
          after: null,
        }
      },
      query() {
        return gql`
          query GET_ACTIVITY($userUid: String!, $order: String, $first: Int, $after: String) {
            activity(userUid: $userUid, order: $order, first: $first, after: $after) {
              nextCursor
              data {
                ... on Comment {
                  ${fields}
                  body
                  parent{ ${fields} body }
                  source{ url }
                }
                ... on Vote {
                  ${fields}
                  value
                  voteable {
                    ...on Source {
                      uid
                      url
                      title
                      h1
                      ogImage
                      createdBy { uid name profileImageUrl }
                      linkPreview {
                        title
                        img
                      }
                    }
                    ...on Comment {
                      uid
                      body
                      createdBy { uid name profileImageUrl }
                      createdAt
                    }
                  }
                }
              }
            }
          }`
      },
    },
  },

})
export default class UserPageActivity extends Vue {
  @Prop() uid!: string
  @Prop() user!: any
  activity: any = null
  order: string = '-created_at'

  pagination: any = {
    nextCursor: '',
  }

  get canNext() {
    return !!(this.activity && this.activity.nextCursor)
  }

  next() {
    if (!this.$apollo.queries.activity) return// @todo see why is there error without this line (when is `next` called?)
    if (this.$apollo.queries.activity && this.$apollo.queries.activity.loading) return
    this.$apollo.queries.activity.fetchMore(<any>{
      variables: {
        userUid: this.uid,
        order: this.order,
        first: pageSize,
        after: this.activity.nextCursor,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newActivity = fetchMoreResult.activity.data
        const nextCursor = fetchMoreResult.activity.nextCursor
        return {
          activity: {
            __typename: previousResult.activity.__typename,
            data: [...previousResult.activity.data, ...newActivity], // Merging the activity
            nextCursor,
          },
        }
      },
    })
  }

  created() {
    window.addEventListener('scroll', () => {
      if (!this.canNext) return
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
        this.next()
      }
    })
  }

  mounted() {
    this.$apollo.queries.activity.refetch()
  }

}

